import CheckMarkIcon from "@assets/icons/new/checkmark-blue-circle-fill_24px.svg?react";
import { blue } from "@flat-ui";
import { Stack, SvgIcon, Typography } from "@mui/material";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";

interface CreditFeatureItemProps {
  /** The text to display as a feature description in the credit package item. */
  featureText: string;
}

/**
 * A component that displays a feature item with a checkmark icon and descriptive text.
 * Used within credit package displays to list included features or benefits.
 */
export function CreditFeatureItem({
  featureText,
}: CreditFeatureItemProps): JSX.Element {
  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={1}
      sx={{ marginBottom: "15px" }}
    >
      <SvgIcon
        component={CheckMarkIcon}
        sx={{
          width: "24px",
          height: "24px",
          color: blue[100],
        }}
      />
      <Typography
        sx={{
          fontSize: DEFAULT_INPUT_FONT_SIZE,
        }}
      >
        {featureText}
      </Typography>
    </Stack>
  );
}
